<template>
  <div>
    <div class="section-card">
      <div class="section-card__head">
        <h4 class="section-card__title">הודעה לעיתונות <span style="color: var(--c-pink-500)">*</span></h4>
        <span class="section-card__hint">יש להעלות גם PDF וגם Word</span>
      </div>
      <div class="fields-row">
        <div class="field-with-info">
          <Dropzone
            title="קומוניקט PDF"
            hint="גררו לכאן קובץ PDF, או לחצו לבחירה"
            accept="pdf"
            :required="true"
            :value="form.comms.pressReleasePdf"
            @update:value="form.comms.pressReleasePdf = $event"
          />
          <FieldInfo field="comms.pressReleasePdf" />
        </div>
        <div class="field-with-info">
          <Dropzone
            title="קומוניקט Word"
            hint="גררו לכאן קובץ Word, או לחצו לבחירה"
            accept="doc,docx"
            :required="true"
            :value="form.comms.pressReleaseDoc"
            @update:value="form.comms.pressReleaseDoc = $event"
          />
          <FieldInfo field="comms.pressReleaseDoc" />
        </div>
      </div>
    </div>

    <div class="section-card">
      <div class="section-card__head">
        <h4 class="section-card__title">מילים וקרדיטים <span style="color: var(--c-pink-500)">*</span></h4>
      </div>
      <div class="fields-row">
        <div class="field-with-info">
          <Dropzone
            title="מילות שירים"
            hint="קובץ Word בלבד"
            accept="doc"
            :required="true"
            :value="form.comms.lyrics"
            @update:value="form.comms.lyrics = $event"
          />
          <FieldInfo field="comms.lyrics" />
        </div>
        <div class="field-with-info">
          <Dropzone
            title="קרדיטים"
            hint="קובץ Word בלבד"
            accept="doc"
            :required="true"
            :value="form.comms.credits"
            @update:value="form.comms.credits = $event"
          />
          <FieldInfo field="comms.credits" />
        </div>
      </div>
      <div class="field" style="margin-top: 12px">
        <label class="field__label field__label--spread">
          <span>קרדיטים — טקסט <span class="req">*</span></span>
          <FieldInfo field="comms.creditsText" />
        </label>
        <div class="rich-text rich-text--rtl">
          <QuillEditor
            v-model:content="form.comms.creditsText"
            content-type="html"
            theme="snow"
            :toolbar="creditsToolbar"
            placeholder="לדוגמה: הפקה: יוני בלוך, מיקס: דנה כהן..."
            dir="rtl"
            @ready="forcePlainPaste"
          />
        </div>
      </div>
      <div class="field" style="margin-top: 12px">
        <label class="field__label">מדבקה — טקסט חופשי <span class="opt">אופציונלי</span> <FieldInfo field="comms.stickerText" /></label>
        <textarea
          v-model="form.comms.stickerText"
          class="input input--textarea"
          placeholder="טקסט שיופיע במדבקה..."
          rows="3"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import Dropzone from '../Dropzone.vue';
import FieldInfo from '../FieldInfo.vue';
import { wizardFormInject } from '../wizardInject.js';
import { forcePlainPaste } from '../../../richText';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
  name: 'StepComms',
  mixins: [wizardFormInject],
  components: { Dropzone, FieldInfo, QuillEditor },
  data() {
    return {
      creditsToolbar: [['bold', 'italic', 'underline']],
    };
  },
  methods: {
    forcePlainPaste,
  },
};
</script>

<style scoped>
.field-with-info {
  position: relative;
  flex: 1;
  min-width: 0;
}
.field-with-info > :deep(.field-info-trigger) {
  position: absolute;
  top: 8px;
  left: 8px;
}
.field__label--spread {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Rich text editor (vue-quill) */
.rich-text {
  background: #fff;
  border-radius: 8px;
}
.rich-text :deep(.ql-toolbar.ql-snow),
.rich-text :deep(.ql-container.ql-snow) {
  border-color: var(--c-border, #d9d9e3);
}
.rich-text :deep(.ql-toolbar.ql-snow) {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.rich-text :deep(.ql-container.ql-snow) {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  font-size: 14px;
}
/* The editable area carries the min-height so the whole box is clickable
   (the container only has min-height, so the editor's height:100% can't fill it). */
.rich-text :deep(.ql-editor) {
  min-height: 120px;
}
.rich-text--rtl :deep(.ql-container),
.rich-text--rtl :deep(.ql-editor) {
  direction: rtl;
}
.rich-text--rtl :deep(.ql-editor) {
  text-align: right;
}
.rich-text--rtl :deep(.ql-editor.ql-blank)::before {
  right: 15px;
  left: 15px;
  text-align: right;
  font-style: normal;
}
</style>
